/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Fri Mar 26 2021 13:32:44 GMT+0100 (czas środkowoeuropejski standardowy)
 */

import { API_URLS } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';
import { AssetUseRequest } from './proposal';
import { AssetCatalogResponse } from './assetconfig';

const URL = API_URLS.ASSETS;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface AssetFVCalculationParams {
  parcontextid: number;
  assetid: number;
  contextid: number;
  duration: number;
  mode: string; // INIT : simulation, MVUPDATE : Update of a contextid with a new Market Value, USEUPDATE : Update of a contextid with a useCondition
  newmarketvalue: number; // mandatory if mode = MVUPDATE
  newvaluedate: string; // mandatory if mode != INIT
  proctaskid: number; // mandatory if mode != INIT
  useCondition: Array<AssetUseConditionRequest>; // mandatory if mode = USEUPDATE
  paymentSchedule: Array<PaymentSchedule>; // INIT MODE : nice to have : to adjust FV dates with PaymentSchedule dates
  assetnetamount: number; // to use when simulate FV for AssetCatalog. in that case, assetid is not mandatory
}

export interface PaymentSchedule {
  ctsorder: number;
  ctstype: string;
  ctsterm: string; //
  ctsperiodicity: number; // 1, 3, 12...,
  ctsperiodicityunit: string; // Day / Month
  ctsduedate: string;
  ctsstartdate: string;
  ctsenddate: string;
  ctsstartamount: number;
  ctsamortizedamount: number;
  ctsinterestamount: number;
  ctsrentalamount: number;
  ctsoutstandingamount: number;
}

export interface Asset {
  assetComponents: Array<AssetComponent>;
  assetcategory: string;
  assetconstructor: string;
  assetdeliverydate: string;
  assetdeliveryreference: string;
  assetdescription: string;
  assetgrossamount: number;
  assetid: number;
  assetlabel: string;
  assetmodel: string;
  assetmodellabel: string;
  assetmulticomponents: boolean;
  assetnetamount: number;
  assetorderdate: string;
  assetorderreference: string;
  assetphase: string;
  assetreference: string;
  assetrisklevel: string;
  assetstatus: string;
  assetstatusdate: string;
  assettaxamount: number;
  assettype: string;
  chassisno: string;
  created_at: string;
  created_by: number;
  currcode: string;
  deliveryadrcity: string;
  deliveryadrcountry: string;
  deliveryadrregion: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrzipcode: string;
  engineno: string;
  fiscaldepreciationmethod: string;
  flagused: boolean;
  last_action: string;
  plateno: string;
  power: string;
  registrationno: string;
  serialno: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  updated_at: string;
  updated_by: number;
  weight: string;
  flagholdback: boolean;
  holdbackpercentage: number;
  holdbackamount: number;
  holdbackbeleasenbdays: number;
  holdbackbeleasedate: string;
  kwhpower: number;
  kwhproduction: number;
  kwhdegradation: number;
}

export interface AssetComponent {
  asset: Asset;
  compcategory: string;
  compdescription: string;
  compdiscountamount: number;
  compdiscountrate: number;
  compfree1: string;
  compgrossamount: number;
  compid: number;
  compnetamount: number;
  comporiginalnetamount: number;
  comptaxamount: number;
  comptype: string;
  taxcode: string;
  taxrate: number;
  suppliername: string;
  supplierreference: string;
  tpidsupplier: number;
  flagholdback: boolean;
  holdbackpercentage: number;
  holdbackamount: number;
  holdbackbeleasenbdays: number;
  holdbackbeleasedate: string;
  catalogidtarget: number;
  catalogidtargetlabel: string;
}

export interface AssetComponentResponse {
  assetid: number;
  compcategory: string;
  compdescription: string;
  compdiscountamount: number;
  compdiscountrate: number;
  compfree1: string;
  compgrossamount: number;
  compid: number;
  compnetamount: number;
  comporiginalnetamount: number;
  comptaxamount: number;
  comptype: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  suppliername: string;
  supplierreference: string;
  flagholdback: boolean;
  holdbackpercentage: number;
  holdbackamount: number;
  holdbackbeleasenbdays: number;
  holdbackbeleasedate: string;
}

export interface AssetConElementResponse {
  assetid: number;
  associd: number;
  cteid: number;
  cteorder: number;
  ctestatus: string;
  ctestatuslabel: string;
  ctreference: string;
  ctrid: number;
  ctstatus: string;
  ctstatuslabel: string;
  endate: string;
  finamountin: number;
  finamountout: number;
  originalamount: number;
  startdate: string;
  tpid: number;
  tpname: string;
  tpreference: string;
  rvauthid: number;
  rvtaskid: number;
  rateauthid: number;
  ratetaskid: number;
  frauthid: number;
  frtaskid: number;
  durationauthid: number;
  durationtaskid: number;
  propreference: String;
  outstandingAmount: number;
}

export interface AssetListResponse {
  assetcategory: string;
  assetdeliverydate: string;
  assetdeliveryreference: string;
  assetdescription: string;
  assetgrossamount: number;
  assetid: number;
  assetlabel: string;
  assetmulticomponents: boolean;
  assetnetamount: number;

  assetoriginalnetamount: number;
  assetdiscountrate: number;
  assetdiscountamount: number;

  assetorderdate: string;
  assetorderreference: string;
  assetreference: string;
  assetstatus: string;
  assettaxamount: number;
  assettype: string;
  clientname: string;
  clientreference: string;
  compid: number;
  ctreference: string;
  ctrid: number;
  refsupplier: string;
  currcode: string;
  suppliername: string;
  tpidclient: number;
  tpidsupplier: number;
  taxcode: string;
  flagholdback: boolean;
  holdbackpercentage: number;
  holdbackamount: number;
  holdbackbeleasenbdays: number;
  holdbackbeleasedate: string;
}

export interface AssetListSearchResponse {
  assetComponents: Array<AssetComponentResponse>;
  assetCatalogServices: Array<AssetServiceResponse>;
  assetphase: string;
  assetpictureurl: string;
  assetqty: number;
  finassetamountin: number;
  assetsegment: string;
  assetsegmentlabel: string;
  assetcategory: string;
  assetcategorylabel: string;
  assetdeliverydate: string;
  assetdeliveryreference: string;
  assetdescription: string;
  assetfamily: string;
  assetfamilylabel: string;
  tpidmanufacturer: number;
  manufacturerreference: string;
  manufacturername: string;
  assetgrossamount: number;
  assetid: number;
  assetlabel: string;
  assetmulticomponents: boolean;
  assetnetamount: number;
  assetorderdate: string;
  assetorderreference: string;
  assetreference: string;
  assetstatus: string;
  assettaxamount: number;
  assettype: string;
  assettypelabel: string;
  clientname: string;
  clientreference: string;
  ctreference: string;
  ctrid: number;
  propreference: string;
  refsupplier: string;
  statuslabel: string;
  suppliername: string;
  supplierreference: string;
  tpidclient: number;
  tpidsupplier: number;
  currcode: string;
  kwhpower: number;
  kwhproduction: number;
  kwhdegradation: number;
  assetconstructor: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrcity: string;
  deliveryadrregion: string;
  deliveryadrcountry: string;
  deliveryadrzipcode: string;
  catalogid: number;
  assetmodel: string;
  assetclass: string;
  assetmodellabel: string;
  taxcode: string;
  taxrate: number;
  assetfinamount: number;
  flagholdback: boolean;
  holdbackpercentage: number;
  holdbackamount: number;
  holdbackbeleasenbdays: number;
  holdbackbeleasedate: string;
  assetstatusdate: string;
  chassisno?: string;
  age: number;
  engineno: string;
  assetrisklevel: string;
  fiscaldepreciationmethod: string;
  plateno: string;
  power: string;
  registrationno: string;
  serialno: string;
  weight: string;
  entityAddAttributList: Array<ViewEntityAddAttributeResponse>;
  balersize?: string;
  balersizelabel?: string;
  separatortype?: string;
  separatortypelabel?: string;
  wheeldrive?: string;
  wheeldrivelabel?: string;
  transmission?: string;
  transmissionlabel?: string;
  wheeltrack?: string;
  lift?: number;
  capacity?: number;
  tankcapacity?: number;
  nbcampaign?: number;
  threshinghours?: number;
  rotorhours?: number;
  totalhours?: number;
  totalbalers?: number;
  registrationdate?: string;
  registrationcity?: string;
  registrationname?: string;
  firstregistrationdate?: string;
  fiscalpower?: number;
  assetexpdeliverydate?: string;
  country?: string;
  networkcode: string;
}

export interface AssetUseCriteria {
  assetfamily: string;
  assettype: string;
  assetcategory: string;
  catalogid: number;
  attcode: string;
  attvalue: number;
}

export interface FilteringCriteria {
  critcode: string;
  critvalue: string;
}

export interface prFilteringCriteria {
  assetUseCriteria: Array<AssetUseCriteria>;
  flagApplyAssetUse?: boolean;
  flagApplyAttributesExtendDurationValues?: boolean;
  flagApplyAttributesExtendFirstRentalValues?: boolean;
  flagApplyAttributesExtendRVValues?: boolean;
  flagApplyAttributesExtendRateValues?: boolean;
  flagApplyExtendDurationValues?: boolean;
  flagApplyExtendFirstRentalValues?: boolean;
  flagApplyExtendRVValues?: boolean;
  flagApplyExtendRateValues?: boolean;
  offerCriteria: Array<FilteringCriteria>;
  prcode: string;
  tpid: number;
}

export interface AssetServiceRequest {
  associd: number;
  assetid?: number;
  servcode: string;
  servfixedamount: number;
  servpercentage: number;
}

export interface AssetServiceResponse {
  associd: number;
  assetid?: number;
  catalogid: number;
  servcode: string;
  servfixedamount: number;
  servfixedamountdefault: number;
  servlabel: string;
  servpercentage: number;
  servpercentagedefault: number;

  servuseunit: string;
  servusefrequency: string;
  servuseunitlabel: string;
  servusefrequencylabel: string;

  servuseqty: number;
  servuseminamount: number;
  servusemaxamount: number;
  servusecoverage: number;
  servusedeductionamount: number;
  servusedeductionpercenrage: number;
  servdescription: string;
  cteid: number;
  startdate: string;
  enddate: string;
  status: string;
}

export interface AssetFeesRequest {
  assetid: number;
  feescategory: string;
  feescreationdate: string;
  feesdescription: string;
  feesdiscountamount: number;
  feesdiscountrate: number;
  feesid: number;
  feesnetamount: number;
  feesoriginalnetamount: number;
  feesstatus: string;
  feesstatusdate: string;
  feestaxamount: number;
  feestype: string;
  feesuserid: number;
  feesvaluedate: string;
  fessgrossamount: number;
  flagrebilling: boolean;
  picture1after: string;
  picture1before: string;
  picture2after: string;
  picture2before: string;
  picture3after: string;
  picture3before: string;
  taskid: number;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
}

export interface AssetFeesResponse {
  assetid: number;
  feescategory: string;
  feescategorylabel: string;
  feescreationdate: string;
  feesdescription: string;
  feesdiscountamount: number;
  feesdiscountrate: number;
  feesid: number;
  feesnetamount: number;
  feesoriginalnetamount: number;
  feesstatus: string;
  feesstatusdate: string;
  feesstatuslabel: string;
  feestaxamount: number;
  feestype: string;
  feestypelabel: string;
  feesuserid: number;
  feesvaluedate: string;
  fessgrossamount: number;
  flagrebilling: boolean;
  picture1after: string;
  picture1before: string;
  picture2after: string;
  picture2before: string;
  picture3after: string;
  picture3before: string;
  suppliername: string;
  supplierreference: string;
  taskid: number;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
}

export interface AssetRequest {
  assetComponents: Array<AssetComponent>;
  listrv: Array<AssetRVAmountResponse>;
  irvSchedule: Array<IrvScheduleRequest>;
  entityAddAttributList?: Array<EntityAdditionalAttributeRequest>;
  assetServiceList: Array<AssetServiceRequest>;
  assetusereqList: Array<AssetUseRequest>;
  assetpictureurl: string;
  assetqty: number;
  assetunitnetamount: number;
  assetqtyavailable: number;
  assetphase: string;

  assetcategory: string;
  assetconstructor: string;
  assetdeliverydate: string;
  assetdeliveryreference: string;
  assetdescription: string;
  assetgrossamount: number;
  assetid: number;
  assetlabel: string;
  assetmodel: string;
  assetmulticomponents: boolean;
  assetnetamount: number;
  assetorderdate: string;
  assetorderreference: string;
  assetreference: string;
  assetrisklevel: string;
  assetstatus: string;
  assettaxamount: number;
  assettype: string;
  chassisno: string;
  currcode: string;
  deliveryadrcity: string;
  deliveryadrcountry: string;
  deliveryadrregion: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrzipcode: string;
  engineno: string;
  fiscaldepreciationmethod: string;
  flagused: boolean;
  plateno: string;
  power: string;
  registrationno: string;
  serialno: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  weight: string;
  assetfamily: string;
  assetsegment: string;
  catalogid: number;
  assetrvamount: number;
  flagholdback: boolean;
  holdbackpercentage: number;
  holdbackamount: number;
  holdbackbeleasenbdays: number;
  holdbackbeleasedate: string;
  kwhpower: number;
  kwhproduction: number;
  kwhdegradation: number;
  networkcode: string;
  tpidbroker: number;
  assetfinamount: number;
  degfeesformula: number;
  spfeesformula: number;
  tpofformula: number;
  country: string;
}

export interface IrvSchedule {
  irvorder: number;
  startdate: string;
  enddate: string;
  rvpercentage: number;
  irvamount: number;
  finrvamount: number;
  rvgap: number;
  trg: number;
  finrvwithtrg: number;
  rvgapwithtrg: number;
  rentalpart: number;
  interestpart: number;
  capitalpart: number;
  ctstype: string;
}

export interface IrvScheduleRequest {
  irvid: number;
  irvorder: number;
  startdate: string;
  enddate: string;
  rvpercentage: number;
  irvamount: number;
  finrvamount: number;
  rvgap: number;
  trg: number;
  finrvwithtrg: number;
  rvgapwithtrg: number;
  rentalpart: number;
  interestpart: number;
  capitalpart: number;
  ctstype: string;
}
export interface AssetComponentPaymentScheduleRequest {
  action: string;
  compid: number;
  dueamount: number;
  holdbackamount: number;
  holdbackpercentage: number;
  holdbackprevreleasedate: string;
  holdbackreleasedate: string;
  payamount: number;
  paycomment: string;
  paydate: string;
  payduedate: string;
  paymentdelaycode: string;
  paypercentage: number;
  paystatus: string;
  paytype: string;
  previsionalduedate: string;
  psid: number;
  psorder: number;
}

export interface AssetpaymentscheduleRequest {
  action: string;
  assetid: number;
  dueamount: number;
  holdbackamount: number;
  holdbackpercentage: number;
  holdbackprevreleasedate: string;
  holdbackreleasedate: string;
  payamount: number;
  paycomment: string;
  paydate: string;
  payduedate: string;
  paymentdelaycode: string;
  paypercentage: number;
  paystatus: string;
  paytype: string;
  previsionalduedate: string;
  psid: number;
  psorder: number;
}
export interface Assetpaymentschedule {
  assetid: number;
  dueamount: number;
  holdbackamount: number;
  holdbackpercentage: number;
  holdbackprevreleasedate: string;
  holdbackreleasedate: string;
  payamount: number;
  paycomment: string;
  paydate: string;
  payduedate: string;
  paymentdelaycode: string;
  paypercentage: number;
  paystatus: string;
  paytype: string;
  previsionalduedate: string;
  psid: number;
  psorder: number;
}

export interface AssetComponentPaymentSchedule {
  compid: number;
  dueamount: number;
  holdbackamount: number;
  holdbackpercentage: number;
  holdbackprevreleasedate: string;
  holdbackreleasedate: string;
  payamount: number;
  paycomment: string;
  paydate: string;
  payduedate: string;
  paymentdelaycode: string;
  paypercentage: number;
  paystatus: string;
  paytype: string;
  previsionalduedate: string;
  psid: number;
  psorder: number;
}
export interface IrvScheduleResponse {
  irvid: number;
  irvorder: number;
  startdate: string;
  enddate: string;
  rvpercentage: number;
  irvamount: number;
  finrvamount: number;
  rvgap: number;
  trg: number;
  finrvwithtrg: number;
  rvgapwithtrg: number;
  accountingdate: string;
  accountingreference: string;
  rentalpart: number;
  interestpart: number;
  capitalpart: number;
  ctstype: string;
}

export interface ParAssetCatalogOptionResponse {
  catalogid: number;
  optcode: string;
  optcodelabel: string;
  optgrossamount: number;
  optid: number;
  optnetamount: number;
  optpictureurl: string;
  optpictureurl2: string;
  optpictureurl3: string;
  optpictureurl4: string;
  optpictureurl5: string;
  optpictureurl6: string;
  opttaxamount: number;
  opttaxcode: string;
  optvalue: string;
  optvaluelabel: string;
  flagfreelabel: boolean;
  flagtopropose: boolean;
  startdate: string;
  enddate: string;
}
export interface AssetCatalogUpgradeResponse {
  assetlabel: string;
  assetnetamount: number;
  catalogid: number;
}

export interface AssetResponse {
  cteid: number;
  assetexpdeliverydate: string;
  assetComponents: Array<AssetComponentResponse>;
  irvSchedule: Array<IrvScheduleResponse>;
  assetusereqList: Array<AssetUseResponse>;
  entityAddAttributList: Array<ViewEntityAddAttributeResponse>;
  assetServiceList: Array<AssetServiceResponse>;
  assetCatalogOptionsToPropose: Array<ParAssetCatalogOptionResponse>;
  assetCatalogAvailableOptions?: Array<ParAssetCatalogOptionResponse>;
  assetUpgradeList: Array<AssetCatalogUpgradeResponse>;
  assetpictureurl: string;
  assetcategory: string;
  assetcategorylabel: string;
  partamount?: number;
  partmethod?: string;
  partmethodlabel?: string;
  partnbdays?: number;
  partrate?: number;
  assetconstructor: string;
  assetdeliverydate: string;
  assetdeliveryreference: string;
  assetdescription: string;
  assetgrossamount: number;
  assetid: number;
  assetqty: number;
  assetunitnetamount: number;
  assetlabel: string;
  assetmodel: string;
  assetclass: string;
  assetmodellabel: string;
  assettaggrouping: string;
  assetmulticomponents: boolean;
  assetnetamount: number;
  assetorderdate: string;
  assetorderreference: string;
  assetphase: string;
  assetreference: string;
  assetrisklevel: string;
  assetstatus: string;
  assetstatusdate: string;
  assettaxamount: number;
  assettype: string;
  assettypelabel: string;
  chassisno: string;
  created_at: string;
  created_by: number;
  currcode: string;
  catalogid: number;
  deliveryadrcity: string;
  deliveryadrcountry: string;
  deliveryadrregion: string;
  deliveryadrstreet1: string;
  deliveryadrstreet2: string;
  deliveryadrzipcode: string;
  engineno: string;
  fiscaldepreciationmethod: string;
  flagused: boolean;
  last_action: string;
  plateno: string;
  power: string;
  registrationno: string;
  serialno: string;
  statuslabel: string;
  suppliername: string;
  supplierreference: string;
  taxcode: string;
  taxrate: number;
  tpidsupplier: number;
  tpidmanufacturer: number;
  manufacturerreference: string;
  manufacturername: string;
  updated_at: string;
  updated_by: number;
  weight: string;
  assetfamilylabel: string;
  assetfamily: string;
  assetsegmentlabel: string;
  assetsegment: string;
  listrv: Array<AssetRVAmountResponse>;
  flagholdback: boolean;
  holdbackpercentage: number;
  holdbackamount: number;
  holdbackbeleasenbdays: number;
  holdbackbeleasedate: string;
  kwhpower: number;
  kwhproduction: number;
  kwhdegradation: number;
  networkcode?: string;
  tpidbroker?: number;
  assetfinamount?: number;
  degfeesformula?: number;
  spfeesformula?: number;
  tpofformula?: number;
  brokername?: string;
  brokerreference?: string;
  age?: number;
  balersize?: string;
  balersizelabel?: string;
  separatortype?: string;
  separatortypelabel?: string;
  wheeldrive?: string;
  wheeldrivelabel?: string;
  transmission?: string;
  transmissionlabel?: string;
  wheeltrack?: string;
  lift?: number;
  capacity?: number;
  tankcapacity?: number;
  nbcampaign?: number;
  threshinghours?: number;
  rotorhours?: number;
  totalhours?: number;
  totalbalers?: number;
  country?: string;
  countrylabel?: string;
  entityAddAttribut?: Array<EntityAdditionalAttributeRequest>;
  registrationdate?: string;
  registrationcity?: string;
  registrationname?: string;
  firstregistrationdate?: string;
  fiscalpower?: number;
  assetstatuslabel?: string;
  durationList?: any;
  marksDuration?: any;
  listMarksMillageByDuration?: any;
  rvDuration?: any;
  rvamountByDuration?: any;
  assetCatalog?: AssetCatalogResponse;
}

export interface AssetFVApplicableContextResponse {
  contextcode: string;
  contextcodelabel: string;
  contextorigin: string;
  contextoriginlabel: string;
  duration: number;
  offerid: number;
  offerlabel: string;
  ofrid: number;
  ofrlabel: string;
  ofrtype: string;
  ofrtypelabel: string;
  parcontextid: number;
  prcode: string;
  prcodelabel: string;
}
export interface AssetUseConditionRequest {
  attcode: string;
  usevalue: number;
  usevaluedate: string;
}
export interface AssetFVApplicableContextRequest {
  useCondition: Array<AssetUseConditionRequest>;
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  catalogid: number;
  duration: number;
  mode: string;
  offerid: number;
  ofrid: number;
  ofrtype: string;
  prcode: string;
}
export interface AssetUseValuesRequest {
  assetid: number;
  attcode: string;
  creationdate: string;
  flagupdatefv: boolean;
  flagupdatemv: boolean;
  newmarketvalue: number;
  proctaskid: number;
  useid: number;
  useridcreation: number;
  usevalue: number;
  usevaluedate: string;
  valueid: number;
}

export interface AssetUseValuesResponse {
  assetid: number;
  attcode: string;
  creationdate: string;
  flagupdatefv: boolean;
  flagupdatemv: boolean;
  newmarketvalue: number;
  proctaskid: number;
  useid: number;
  useridcreation: number;
  usevalue: number;
  usevaluedate: string;
  valueid: number;
}
export interface AssetUseResponse {
  assetid: number;
  attcode: string;
  condid: number;
  defaultvalue: number;
  id: number;
  initmarketvalue: number;
  lastregistredusedate: string;
  lastregistredusevalue: number;
  maxvalue: number;
  minvalue: number;
  newmarketvalue: number;
  offerid: number;
  offerlabel: string;
  ofrid: number;
  ofrlabel: string;
  ofrtype: string;
  prcode: string;
  prcodeLabel: string;
  priidexceed: number;
  priidexceedLabel: string;
  priidexceedlabel: string;
  useLabel: string;
  useValues: Array<AssetUseValuesResponse>;
  useid: number;
  uselabel: string;
  usestatus: string;
  useunitperiod: string;
  useunitperiodlabel: string;
  useunittype: string;
  useunittypelabel: string;
  usevalue: number;
  usevaluedate: string;
  usevaluetype: string;
}

export interface AssetFutureValueScheduleResponse {
  finrvamount: number;
  fvamount: number;
  fvdate: string;
  fvid: number;
  fvpercentage: number;
  fvstatus: string;
  proctaskid: number;
  parfvid: number;
}

export interface AssetFutureValueScheduleRequest {
  finrvamount: number;
  fvamount: number;
  fvdate: string;
  startdate: string;
  fvpercentage: number;
  fvstatus: string;
  proctaskid: number;
  parfvid: number;
}
export interface AssetFutureValueContextUseResponse {
  attcode: string;
  attcodelabel: string;
  fvuseid: number;
  usevalue: number;
}

export interface AssetFutureValueContextUseRequest {
  attcode: string;
  usevalue: number;
}

export interface AssetAddress {
  adrenddate: string;
  adrstartdate: string;
  adrstatus: string;
  adrstatusdate: string;
  adrtype: string;
  assetadrid: number;
  assetid: number;
  assetmainadrcity: string;
  assetmainadrcountry: string;
  assetmainadrregion: string;
  assetmainadrstreet1: string;
  assetmainadrstreet2: string;
  assetmainadrzipcode: string;
  assetgpslng: string;
  assetgpslat: string;
}

export interface AssetUsers {
  assetid: number;
  assetrelid: number;
  creationdate: string;
  enddate: string;
  relcode: string;
  reltype: string;
  relvalue: string;
  startdate: string;
  tpidtarget: number;
  updatedate: string;
  useridcreate: number;
  useridupdate: number;
}

export interface AssetUsersResponse {
  tptargetname: string;
  assetid: number;
  assetname: string;
  assetrelid: number;
  creationdate: string;
  enddate: string;
  relcode: string;
  reltype: string;
  relvalue: string;
  startdate: string;
  tpidtarget: number;
  updatedate: string;
  useridcreate: number;
  useridupdate: number;
}

export interface AssetDepreciationValues {
  assetid: number;
  assetnetamount: number;
  assetrvamount: number;
  assetvalueamount: number;
  assetvaluedate: string;
  basisamount: number;
  coefficient: number;
  contextid: number;
  deprcontext: string;
  deprcontextlabel: string;
  deprmethod: string;
  deprmethodlabel: string;
  durationmonths: number;
  durationyear: number;
  enddate: string;
  startdate: string;
}
export interface AssetFutureValues {
  assetid: number;
  contextcode: string;
  contextcodelabel: string;
  contextid: number;
  contextidorigine: number;
  contextidoriginlabel: string;
  finrvamount: number;
  fvamount: number;
  fvdate: string;
  fvtype: string;
  fvtypelabel: string;
  parcontextid: number;
}
export interface AssetValues {
  assetfinamount: number;
  assetfinrvamount: number;
  assetid: number;
  assetirvamount: number;
  assetlabel: string;
  assetnetamount: number;
  assetreference: string;
  assetrvamount: number;
  assetstatus: string;
  assetstatusdate: string;
  assetvaluesdate: string;
  deliverydate: string;
  depreciationValues: Array<AssetDepreciationValues>;
  futureValues: Array<AssetFutureValues>;
  marketvalue: number;
  marketvaluedate: string;
  marketvalueorigin: string;
  statuslabel: string;
}
export interface AssetAddressResponse2 {
  adrenddate: string;
  adrstartdate: string;
  adrstatus: string;
  adrstatusdate: string;
  adrstatuslabel: string;
  adrtype: string;
  adrtypelabel: string;
  assetadrid: number;
  assetid: number;
  assetmainadrcity: string;
  assetmainadrcitylabel: string;
  assetmainadrcountry: string;
  assetmainadrcountrylabel: string;
  assetmainadrregion: string;
  assetmainadrregionlabel: string;
  assetmainadrstreet1: string;
  assetmainadrstreet2: string;
  assetmainadrzipcode: string;
  assetmainadrzipcodelabel: string;
  bkbranchename: string;
  assetgpslng: string;
  assetgpslat: string;
}
export interface AssetFutureValueResponse {
  fvContextUse: Array<AssetFutureValueContextUseResponse>;
  fvSchedule: Array<AssetFutureValueScheduleResponse>;
  assetid: number;
  contextcode: string;
  contextcodelabel: string;
  contextid: number;
  contextidorigine: number;
  contextidoriginelabel: string;
  contextorigin: string;
  contextoriginelabel: string;
  contextstatus: string;
  contextstatuslabel: string;
  creationdate: string;
  duration: number;
  fvtype: string;
  fvtypelabel: string;
  offerid: number;
  offerlabel: string;
  ofrid: number;
  ofrlabel: string;
  ofrtype: string;
  ofrtypelabel: string;
  parcontextid: number;
  prcode: string;
  prcodelabel: string;
  useridcreation: number;
}

export interface AssetFutureValueRequest {
  fvContextUse: Array<AssetFutureValueContextUseRequest>;
  fvSchedule: Array<AssetFutureValueScheduleRequest>;
  assetid: number;
  contextcode: string;
  contextid: number;
  contextidorigine: number;
  contextorigin: string;
  contextstatus: string;
  creationdate: string;
  duration: number;
  fvtype: string;
  offerid: number;
  ofrid: number;
  ofrtype: string;
  parcontextid: number;
  prcode: string;
}

export interface GetNotInvoicedAssetByAnyRefParams {
  assetreference: string;
  ctreference: string;
  deliveryreference: string;
  idsupplier: number;
  orderreference: string;
  complevel: boolean;
  currcode: string;
}
/**
 * @tags Asset Controller
 * @summary getNotInvoicedAssetByAnyRef
 */
export function getNotInvoicedAssetByAnyRef(
  params: GetNotInvoicedAssetByAnyRefParams
) {
  return request.get<AbstractResponse<unknown, AssetListResponse>>(
    `${URL}/api/assetNotInvoiced` +
      prepareQueryParams({
        assetreference: params.assetreference,
        ctreference: params.ctreference,
        deliveryreference: params.deliveryreference,
        idsupplier: params.idsupplier,
        orderreference: params.orderreference,
        complevel: params.complevel,
        currcode: params.currcode,
      } as any)
  );
}

export interface GetAssetListByAnyRefParams {
  assetreference?: string;
  clientname?: string;
  clientreference?: string;
  ctreference?: string;
  deliveryreference?: string;
  orderreference?: string;
  propreference?: string;
  refsupplier?: string;
  assetlabel?: string;
  status?: string;
  phase?: string;
  suppliername?: string;
  manufacturername?: string;
  manufacturerreference?: string;
  chassisno: string;
  plateno: string;
  assetclass?: string;
}

/**
 * @tags Asset Controller
 * @summary getAssetListByAnyRef
 */
export function getAssetListByAnyRef(params: GetAssetListByAnyRefParams) {
  return request.get<AbstractResponse<unknown, AssetListSearchResponse>>(
    `${URL}/api/assets` +
      prepareQueryParams({
        assetreference: params.assetreference,
        assetlabel: params.assetlabel,
        clientname: params.clientname,
        clientreference: params.clientreference,
        ctreference: params.ctreference,
        deliveryreference: params.deliveryreference,
        orderreference: params.orderreference,
        propreference: params.propreference,
        refsupplier: params.refsupplier,
        status: params.status,
        phase: params?.phase,
        suppliername: params.suppliername,
        manufacturername: params.manufacturername,
        manufacturerreference: params.manufacturerreference,
        chassisno: params.chassisno,
        plateno: params.plateno,
        assetclass: params.assetclass,
      } as any)
  );
}

export interface AssetpaymentschedulelistResponse {
  assetdeliverydate: string;
  assetdeliveryreference: string;
  assetid: number;
  assetlabel: string;
  assetmulticomponents: boolean;
  assetorderdate: string;
  assetorderreference: string;
  assetreference: string;
  assetstatus: string;
  clientname: string;
  clientreference: string;
  compid: number;
  cteid: number;
  ctreference: string;
  ctrid: number;
  currcode: string;
  dueamount: number;
  holdbackamount: number;
  holdbackpercentage: number;
  holdbackprevreleasedate: string;
  holdbackreleasedate: string;
  payamount: number;
  paydate: string;
  payduedate: string;
  paymentdelaycode: string;
  paypercentage: number;
  paystatus: string;
  paytype: string;
  previsionalduedate: string;
  psid: number;
  psorder: number;
  refsupplier: string;
  suppliername: string;
  taxcode: string;
  tpidclient: number;
  tpidsupplier: number;
}

export interface AssetLinks {
  assetid: number;
  assetidtarget: number;
  creationdate: string;
  enddate: string;
  linkid: number;
  relcode: string;
  reltype: string;
  relvalue: string;
  startdate: string;
  updatedate: string;
  useridcreate: number;
  useridupdate: number;
}

export interface AssetLinksResponse {
  assetid: number;
  assetidtarget: number;
  assetlabel: string;
  assettargetlabel: string;
  creationdate: string;
  enddate: string;
  linkid: number;
  relcode: string;
  reltype: string;
  relvalue: string;
  startdate: string;
  updatedate: string;
  useridcreate: number;
  useridupdate: number;
}
export interface ParAssetUseConditionResponse {
  condid: number;
  defaultvalue: number;
  maxvalue: number;
  minvalue: number;
  offerid: number;
  ofrid: number;
  ofrlabel: string;
  ofrtype: string;
  ofrtypelabel: string;
  prcode: string;
  priidexceed: number;
  priidexceedlabel: string;
  useid: number;
}

export interface FindAssetPayScheduleByAnyRefParams {
  assetreference: string;
  complevel?: boolean;
  ctreference: string;
  currcode: string;
  deliveryreference: string;
  orderreference: string;
  idsupplier: number;
}

/**
 * @tags Asset Controller
 * @summary findAssetPayScheduleByAnyRef
 */
export function findAssetPayScheduleByAnyRef(
  params: FindAssetPayScheduleByAnyRefParams
) {
  return request.get<
    AbstractResponse<object, AssetpaymentschedulelistResponse>
  >(
    `${URL}/api/assetPaymentScheduleList` +
      prepareQueryParams({
        assetreference: params.assetreference,
        complevel: params.complevel,
        ctreference: params.ctreference,
        currcode: params.currcode,
        deliveryreference: params.deliveryreference,
        orderreference: params.orderreference,
        idsupplier: params.idsupplier,
      } as any)
  );
}

export interface AssetStatusHistoryResponse {
  assetid: number;
  id: number;
  phase: string;
  phaselabel: string;
  status: string;
  statusdate: string;
  statuslabel: string;
  updated_at: string;
  userid: number;
  username: string;
}
export interface GetAssetStatusHistoryParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getAssetStatusHistory
 */
export function getAssetStatusHistory(params: GetAssetStatusHistoryParams) {
  return request.get<AbstractResponse<object, AssetStatusHistoryResponse>>(
    `${URL}/api/asset/statusHistory/${params.assetid}`
  );
}
export interface CreateAssetParams {
  assetRequest: AssetRequest;
}

/**
 * @tags Asset Controller
 * @summary createAsset
 */
export function createAsset(params: CreateAssetParams) {
  return request.post<AbstractResponse<AssetResponse, unknown>>(
    `${URL}/api/assets`,
    params.assetRequest
  );
}

export interface GetAssetsByIDParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getAssetsByID
 */
export function getAssetsByID(params: GetAssetsByIDParams) {
  return request.get<AbstractResponse<AssetResponse, unknown>>(
    `${URL}/api/assets/${params.assetid}`
  );
}

export interface UpdateAssetParams {
  assetRequest: AssetRequest;
  assetid: number;
  cteid?: number;
  phase?: string;
}

/**
 * @tags Asset Controller
 * @summary updateAsset
 */
export function updateAsset(params: UpdateAssetParams) {
  return request.put<AbstractResponse<AssetResponse, object>>(
    `${URL}/api/assets/${params.assetid}` +
      prepareQueryParams({ phase: params.phase, cteid: params.cteid } as any),
    params.assetRequest
  );
}

export interface GetConElementByAssetIDParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getConElementByAssetID
 */
export function getConElementByAssetID(params: GetConElementByAssetIDParams) {
  return request.get<AbstractResponse<unknown, AssetConElementResponse>>(
    `${URL}/api/assets/${params.assetid}/conelements`
  );
}

export interface AssetRepossessionResponse {
  repid: number;
  assetid: number;

  repdecision: string;
  repdecisionlabel: string;
  repevaldate: string;
  assetfinrvamount: number;
  assetirvamount: number;
  marketvalue: number;
  marketvaluedate: number;
  marketvalueorigin: string;
  damage: string;
  recondamount: number;
  transportamount: number;
  storageamount: number;
  marketvalueasis: number;
  saleamount: number;
  gainifrecond: number;
  gainifsale: number;
  repcomment: string;
}
export interface GetAssetRepossessionListByAssetIDParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getDepreciationListByAssetID
 */
export function getAssetRepossessionListByAssetID(
  params: GetAssetRepossessionListByAssetIDParams
) {
  return request.get<AbstractResponse<unknown, AssetRepossessionResponse>>(
    `${URL}/api/asset/assetRepossession/${params.assetid}`
  );
}

/**
 * @tags Asset Controller
 * @summary version
 */
export function version() {
  return request.get<string>(`${URL}/api/version`);
}

export interface ActionsAssetComponentPaymentScheduleParams {
  assetComponentPaymentScheduleRequest: Array<AssetComponentPaymentScheduleRequest>;
}

/**
 * @tags Asset Controller
 * @summary ActionsAssetComponentPaymentSchedule
 */
export function ActionsAssetComponentPaymentSchedule(
  params: ActionsAssetComponentPaymentScheduleParams
) {
  return request.post<
    AbstractResponse<object, AssetComponentPaymentScheduleRequest>
  >(
    `${URL}/api/asset/assetComponentPaymentSchedule`,
    params.assetComponentPaymentScheduleRequest
  );
}

export interface ActionsAssetpaymentscheduleParams {
  assetpaymentscheduleRequest: Array<AssetpaymentscheduleRequest>;
}

/**
 * @tags Asset Controller
 * @summary ActionsAssetpaymentschedule
 */
export function ActionsAssetpaymentschedule(
  params: ActionsAssetpaymentscheduleParams
) {
  return request.post<AbstractResponse<object, AssetpaymentscheduleRequest>>(
    `${URL}/api/asset/assetpaymentschedule`,
    params.assetpaymentscheduleRequest
  );
}

export interface GetAssetpaymentscheduleParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getAssetpaymentschedule
 */
export function getAssetpaymentschedule(params: GetAssetpaymentscheduleParams) {
  return request.get<AbstractResponse<object, Assetpaymentschedule>>(
    `${URL}/api/assetpaymentschedule/${params.assetid}`
  );
}

export interface GetAssetComponentPaymentScheduleParams {
  compid: number;
}

/**
 * @tags Asset Controller
 * @summary getAssetComponentPaymentSchedule
 */
export function getAssetComponentPaymentSchedule(
  params: GetAssetComponentPaymentScheduleParams
) {
  return request.get<AbstractResponse<object, AssetComponentPaymentSchedule>>(
    `${URL}/api/assetComponentPaymentSchedule/${params.compid}`
  );
}

export interface GetAssetUseByAssetIDParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getAssetUseByAssetID
 */
export function getAssetUseByAssetID(params: GetAssetUseByAssetIDParams) {
  return request.get<AbstractResponse<object, AssetUseResponse>>(
    `${URL}/api/asset/assetuse/${params.assetid}`
  );
}

export interface UpdateAssetUseStatusParams {
  assetusestatus: string;
  id: number;
}

/**
 * @tags Asset Controller
 * @summary updateAssetUseStatus
 */
export function updateAssetUseStatus(params: UpdateAssetUseStatusParams) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/asset/assetuse/${params.id}` +
      prepareQueryParams({ assetusestatus: params.assetusestatus } as any)
  );
}

export interface DeleteAssetUseParams {
  id: number;
}

/**
 * @tags Asset Controller
 * @summary deleteAssetUse
 */
export function deleteAssetUse(params: DeleteAssetUseParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/asset/assetuse/${params.id}`
  );
}

export interface CalculateAssetFutureValueParams {
  request: AssetFVCalculationParams;
}

export interface CreateAssetFutureValueParams {
  request: AssetFutureValueRequest;
}
/**
 * @tags Asset Controller
 * @summary calculateAssetFutureValue
 */
export function calculateAssetFutureValue(
  params: CalculateAssetFutureValueParams
) {
  return request.post<AbstractResponse<AssetFutureValueResponse, object>>(
    `${URL}/api/asset/futureValue/calculate`,
    params.request
  );
}

export function createAssetFutureValue(params: CreateAssetFutureValueParams) {
  return request.post<AbstractResponse<AssetFutureValueResponse, object>>(
    `${URL}/api/asset/futureValue/create`,
    params.request
  );
}

export interface GetAssetfutureValueListParams {
  assetid: number;
}

export interface DeleteAssetfutureValueByContextIdParams {
  contextid: number;
}

/**
 * @tags Asset Controller
 * @summary getAssetfutureValue
 */
export function getAssetfutureValueList(params: GetAssetfutureValueListParams) {
  return request.get<AbstractResponse<object, AssetFutureValueResponse>>(
    `${URL}/api/asset/futureValue/${params.assetid}`
  );
}

export function deleteAssetfutureValueByContextId(
  params: DeleteAssetfutureValueByContextIdParams
) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/asset/futureValue/context/${params.contextid}`
  );
}

export interface GetAssetAddresListByassetidParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getAssetAddresListByassetid
 */
export function getAssetAddresListByassetid(
  params: GetAssetAddresListByassetidParams
) {
  return request.get<AbstractResponse<object, AssetAddressResponse2>>(
    `${URL}/api/asset/${params.assetid}/addressList`
  );
}

export interface CreateAssetAddressParams {
  assetAddressRequest: AssetAddress;
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary createAssetAddress
 */
export function createAssetAddress(params: CreateAssetAddressParams) {
  return request.post<AbstractResponse<AssetAddress, object>>(
    `${URL}/api/asset/${params.assetid}/addressList`,
    params.assetAddressRequest
  );
}

export interface GetAssetAddresByIdParams {
  assetadrid: number;
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getAssetAddresById
 */
export function getAssetAddresById(params: GetAssetAddresByIdParams) {
  return request.get<AbstractResponse<AssetAddressResponse2, object>>(
    `${URL}/api/asset/${params.assetid}/addressList/${params.assetadrid}`
  );
}

export interface UpdateAssetAddresParams {
  assetAddressRequest: AssetAddress;
  assetadrid: number;
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary updateAssetAddres
 */
export function updateAssetAddres(params: UpdateAssetAddresParams) {
  return request.put<AbstractResponse<AssetAddress, object>>(
    `${URL}/api/asset/${params.assetid}/addressList/${params.assetadrid}`,
    params.assetAddressRequest
  );
}

export interface DeleteAssetAddressParams {
  assetadrid: number;
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary deleteAssetAddress
 */
export function deleteAssetAddress(params: DeleteAssetAddressParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/asset/${params.assetid}/addressList/${params.assetadrid}`
  );
}

export interface UpdateAssetAddresStatusParams {
  adrstatus: string;
  assetadrid: number;
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary updateAssetAddresStatus
 */
export function updateAssetAddresStatus(params: UpdateAssetAddresStatusParams) {
  return request.put<AbstractResponse<AssetAddress, object>>(
    `${URL}/api/asset/${params.assetid}/addressList/${params.assetadrid}/${params.adrstatus}`
  );
}

export interface AddAssetUsersParams {
  request: AssetUsers;
}

/**
 * @tags Asset Controller
 * @summary addAssetUsers
 */
export function addAssetUsers(params: AddAssetUsersParams) {
  return request.post<AbstractResponse<AssetUsers, object>>(
    `${URL}/api/asset/assetUsers`,
    params.request
  );
}

export interface UpdateAssetUsersParams {
  assetUserid: number;
  request: AssetUsers;
}

/**
 * @tags Asset Controller
 * @summary updateAssetUsers
 */
export function updateAssetUsers(params: UpdateAssetUsersParams) {
  return request.put<AbstractResponse<AssetUsers, object>>(
    `${URL}/api/asset/assetUsers/${params.assetUserid}`,
    params.request
  );
}

export interface DeleteAssetUsersParams {
  assetUserid: number;
}

/**
 * @tags Asset Controller
 * @summary deleteAssetUsers
 */
export function deleteAssetUsers(params: DeleteAssetUsersParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/asset/assetUsers/${params.assetUserid}`
  );
}

export interface GetAssetUsersListByAssetidParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getAssetUsersListByAssetid
 */
export function getAssetUsersListByAssetid(
  params: GetAssetUsersListByAssetidParams
) {
  return request.get<AbstractResponse<object, AssetUsersResponse>>(
    `${URL}/api/asset/assetUsers/${params.assetid}`
  );
}

export interface ViewEntityAddAttributeResponse {
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  attbooleanvalue: boolean;
  attcode: string;
  attlabel?: string;
  attcodeparent: string;
  attdatatype: string;
  attinputtype: string;
  attnbrows: number;
  attnumericvalue: number;
  attstringvalue: string;
  atttextvalue: string;
  colspan: number;
  defautvalue: string;
  displayorder: number;
  displayposition: string;
  displaysection: string;
  displaytype: string;
  entity: string;
  entityid: number;
  entitytype: string;
  maxvalue: string;
  minvalue: string;
  parcode: string;
  prcode: string;
  style: string;
}

export interface GetEntityAdditionaAttributesParams {
  assetcategory: string;
  assetfamily: string;
  assettype: string;
  assetsegment: string;
  assetmodel: string;
  entity: string;
  entityid: number;
  entitytype: string;
  prcode: string;
}

/**
 * @tags Asset Controller
 * @summary getEntityAdditionaAttributes
 */
export function getAssetAdditionalAttributes(
  params: GetEntityAdditionaAttributesParams
) {
  return request.get<AbstractResponse<object, ViewEntityAddAttributeResponse>>(
    `${URL}/api/asset/additionalattribute` +
      prepareQueryParams({
        assetcategory: params.assetcategory,
        assetfamily: params.assetfamily,
        assettype: params.assettype,
        assetsegment: params.assetsegment,
        assetmodel: params.assetmodel,
        entity: params.entity,
        entityid: params.entityid,
        entitytype: params.entitytype,
        prcode: params.prcode,
      } as any)
  );
}

export interface AddAssetUseValueParams {
  request: AssetUseValuesRequest;
}

/**
 * @tags Asset Controller
 * @summary addAssetUseValue
 */
export function addAssetUseValue(params: AddAssetUseValueParams) {
  return request.post<AbstractResponse<AssetUseValuesResponse, object>>(
    `${URL}/api/asset/assetuse/values/add`,
    params.request
  );
}

export interface AddAssetServiceParams {
  request: AssetServiceRequest;
}

/**
 * @tags Asset Controller
 * @summary addAssetService
 */
export function addAssetService(params: AddAssetServiceParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/asset/assetServices`,
    params.request
  );
}

export interface UpdateAssetServiceParams {
  request: AssetServiceRequest;
}

/**
 * @tags Asset Controller
 * @summary updateAssetService
 */
export function updateAssetService(params: UpdateAssetServiceParams) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/asset/assetServices`,
    params.request
  );
}

export interface GetAssetServicesListByAssetidParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getAssetServicesListByAssetid
 */
export function getAssetServicesListByAssetid(
  params: GetAssetServicesListByAssetidParams
) {
  return request.get<AbstractResponse<object, AssetServiceResponse>>(
    `${URL}/api/asset/assetServices/${params.assetid}`
  );
}

export interface DeleteAssetServiceParams {
  associd: number;
}

/**
 * @tags Asset Controller
 * @summary deleteAssetService
 */
export function deleteAssetService(params: DeleteAssetServiceParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/asset/assetServices/${params.associd}`
  );
}

export interface AddAssetFeesParams {
  request: AssetFeesRequest;
}

/**
 * @tags Asset Controller
 * @summary addAssetFees
 */
export function addAssetFees(params: AddAssetFeesParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/asset/assetFees`,
    params.request
  );
}

export interface UpdateAssetFeesParams {
  feesid: number;
  request: AssetFeesRequest;
}

/**
 * @tags Asset Controller
 * @summary updateAssetFees
 */
export function updateAssetFees(params: UpdateAssetFeesParams) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/asset/assetFees/${params.feesid}`,
    params.request
  );
}
export interface GetAssetFeesListByAssetidParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getAssetFeesListByAssetid
 */
export function getAssetFeesListByAssetid(
  params: GetAssetFeesListByAssetidParams
) {
  return request.get<AbstractResponse<object, AssetFeesResponse>>(
    `${URL}/api/asset/assetFees/${params.assetid}`
  );
}

export interface DeleteAssetFeesParams {
  feesid: number;
}

/**
 * @tags Asset Controller
 * @summary deleteAssetFees
 */
export function deleteAssetFees(params: DeleteAssetFeesParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/asset/assetFees/${params.feesid}`
  );
}

export interface UpdateAssetFeesStatusParams {
  feesid: number;
  status: string;
}

/**
 * @tags Asset Controller
 * @summary updateAssetFeesStatus
 */
export function updateAssetFeesStatus(params: UpdateAssetFeesStatusParams) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/asset/assetFees/${params.feesid}/${params.status}`
  );
}

export interface EntityAdditionalAttributeRequest {
  attbooleanvalue: boolean | null;
  attcode: string;
  attnumericvalue: number;
  attstringvalue: string;
  atttextvalue: string;
  attdatatype?: string;
  entity: string;
  entityid: number;
  id: number;
}

export interface AssetRVAmountResponse {
  rvid: number;
  mgid: number;
  assetid: number;
  prcode: string;
  assettype: string;
  assetcategory: string;
  assetamount: number;
  monthsmin: number;
  monthsmax: number;
  rvevaluationmode: string;
  rvfixedamount: number;
  rvpercentage: number;
  rvamount: number;
}

export interface GetAssetLinksListByAssetidParams {
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary getAssetLinksListByAssetid
 */
export function getAssetLinksListByAssetid(
  params: GetAssetLinksListByAssetidParams
) {
  return request.get<AbstractResponse<object, AssetLinksResponse>>(
    `${URL}/api/asset/${params.assetid}/links`
  );
}

export interface AddAssetLinksParams {
  request: AssetLinks;
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary addAssetLinks
 */
export function addAssetLinks(params: AddAssetLinksParams) {
  return request.post<AbstractResponse<AssetLinks, object>>(
    `${URL}/api/asset/${params.assetid}/links`,
    params.request
  );
}

export interface UpdateThirdPartyReltionParams {
  linkid: number;
  request: AssetLinks;
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary updateThirdPartyReltion
 */
export function updateThirdPartyReltion(params: UpdateThirdPartyReltionParams) {
  return request.put<AbstractResponse<AssetLinks, object>>(
    `${URL}/api/asset/${params.assetid}/links/${params.linkid}`,
    params.request
  );
}

export interface DeleteThirdPartyReltionParams {
  linkid: number;
  assetid: number;
}

/**
 * @tags Asset Controller
 * @summary deleteThirdPartyReltion
 */
export function deleteThirdPartyReltion(params: DeleteThirdPartyReltionParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/asset/${params.assetid}/links/${params.linkid}`
  );
}

export interface FindAssetByPartnerParams {
  catalogid?: number;
  enddate?: string;
  model?: string;
  startdate?: string;
  status?: string;
  tpid: number;
  role: string;
  variant?: string;
}

export function findAssetByPartner(params: FindAssetByPartnerParams) {
  return request.get<AbstractResponse<object, AssetListSearchResponse>>(
    `${URL}/api/assetByPartner` +
      prepareQueryParams({
        catalogid: params.catalogid,
        enddate: params.enddate,
        model: params.model,
        startdate: params.startdate,
        status: params.status,
        tpid: params.tpid,
        role: params.role,
        variant: params.variant,
      } as any)
  );
}

export interface GetParAssetUseConditionDetailByUsedidParams {
  useid: number;
  usevalue: number;
}

/**
 * @tags Par Asset Use Controller
 * @summary getParAssetUseConditionDetailByUsedid
 */
export function getParAssetUseConditionDetailByUsedid(
  params: GetParAssetUseConditionDetailByUsedidParams
) {
  return request.get<AbstractResponse<ParAssetUseConditionResponse, object>>(
    `${URL}/api/config/parassetusecondition/byValue` +
      prepareQueryParams({
        useid: params.useid,
        usevalue: params.usevalue,
      } as any)
  );
}

/// assetserviceUSe :

export interface AssetServiceUseResponse {
  useid: number;
  associd: number;
  assetid: number;
  cteid: number;
  servcode: string;
  currcode: string;
  creationdate: string;
  useridcrearion: number;
  requestdate: string;
  requeststatus: string;
  validationdate: string;
  useridvalidation: number;
  supplierid: number;
  suppliername: string;
  supplierreference: string;
  requestedamount: number;
  requestedqty: number;
  acceptedamount: number;
  acceptedqty: number;
  useramounttobeinvoiced: number;
  suppliervalidatedamount: number;
  usecomment: string;
  poorderreference: string;
  externalreference: string;
  siid: number;
  ciid: number;
  taskid: number;
  kilometerscounter: number;
}

export interface AssetServiceUseRequest {
  useid: number;
  associd: number;
  assetid: number;
  cteid: number;
  servcode: string;
  currcode: string;
  creationdate: string;
  useridcrearion: number;
  requestdate: string;
  requeststatus: string;
  validationdate: string;
  useridvalidation: number;
  supplierid: number;
  suppliername: string;
  supplierreference: string;
  requestedamount: number;
  requestedqty: number;
  acceptedamount: number;
  acceptedqty: number;
  useramounttobeinvoiced: number;
  suppliervalidatedamount: number;
  usecomment: string;
  poorderreference: string;
  externalreference: string;
  siid: number;
  ciid: number;
  taskid: number;
  kilometerscounter: number;
}

export interface AddAssetServiceUseParams {
  request: AssetServiceUseRequest;
}

/**
 * @tags Asset Controller
 * @summary addAssetService
 */
export function addAssetServiceUse(params: AddAssetServiceUseParams) {
  return request.post<AbstractResponse<object, object>>(
    `${URL}/api/asset/assetServiceUse`,
    params.request
  );
}

export interface UpdateAssetServiceUseParams {
  request: AssetServiceUseRequest;
}

/**
 * @tags Asset Controller
 * @summary updateAssetService
 */
export function updateAssetServiceUse(params: UpdateAssetServiceUseParams) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/asset/assetServiceUse`,
    params.request
  );
}

export interface GetAssetServiceUseListByAssocidParams {
  associd: number;
}

/**
 * @tags Asset Controller
 * @summary getAssetServicesListByAssetid
 */
export function getAssetServiceUseListByAssocid(
  params: GetAssetServiceUseListByAssocidParams
) {
  return request.get<AbstractResponse<object, AssetServiceUseResponse>>(
    `${URL}/api/asset/assetServiceUse/${params.associd}`
  );
}

export interface AssetServiceUseByCriteriaParams {
  assetid: number;
  servcode:String;
  creationdate:String
  validationdate:String
  poorderreference:String
  useid:number
  suppliername:String
}

/**
 * @tags Asset Controller
 * @summary getAssetServicesListByAssetid
 */
export function getAssetServiceUseByCriteria(
  params: AssetServiceUseByCriteriaParams
) {
  return request.get<AbstractResponse<object, AssetServiceUseResponse>>(
    `${URL}/api/asset/assetServiceUseByCriteria/${params.assetid}` +
    prepareQueryParams({ 
    servcode:params.servcode,
    creationdate:params.creationdate,
    validationdate:params.validationdate,
    poorderreference:params.poorderreference,
    useid:params.useid,
    suppliername:params.suppliername
      } as any)
  );
}

export interface UpdateAssetServiceUseStatusParams {
  useid: number;
  status: string;
}

export function updateAssetServiceUseStatus(
  params: UpdateAssetServiceUseStatusParams
) {
  return request.put<AbstractResponse<object, object>>(
    `${URL}/api/asset/assetServiceUse/${params.useid}/${params.status}`
  );
}

export interface DeleteAssetServiceUseParams {
  useid: number;
}

/**
 * @tags Asset Controller
 * @summary deleteAssetService
 */
export function deleteAssetServiceUse(params: DeleteAssetServiceUseParams) {
  return request.delete<AbstractResponse<object, object>>(
    `${URL}/api/asset/assetServiceUse/${params.useid}`
  );
}
